<div class="area-filter-header">
  <div class="area-filter-header-text">{{ 'AREAS' | translate | uppercase }}</div>
</div>
<!-- *ngIf="areaService.areasNames.length > 0" -->
<div class="area-filter-content">
  <div class="area-filter-content-container">
    <ul class="area-filter-areas-list">
      <!-- <li class="area-filter-area" *ngFor="let area of getSortedAreasByNames()" [class.selected]="area.isSelected" [class.hidden]="!area.isSelected" (click)="clickOnArea(area.id)">
          -{{ test(area.name) | translatedb }}
      </li> -->
      <li class=" area-filter-area " *ngFor="let area of areasListnew" [class.selected]="area.isSelected "
          [class.hidden]="area.isSelected " (click)="clickOnArea(area.id) ">
        -{{ test(area.name) | translatedb }}
      </li>
    </ul>
  </div>
</div>
